import Organizations from './organizations/Organizations';
import Translations from './translations/Translations';
import Reference from './reference/Reference';
import ClaimTypes from './claimTypes/ClaimTypes';
import { lazy } from 'react';
import { authRoles } from 'src/app/auth';
import ClaimStatuses from './claimStatuses/ClaimStatuses';
import AbsenceAsksStatuses from './absenceAsksStatuses/AbsenceAsksStatuses';
import AbsenceAsksCategories from './absenceAsksCategories/AbsenceAsksCategories';
import AbsenceAsksSubCategories from './absenceAsksSubCategories/AbsenceAsksSubCategories';
import ProjectStatuses from './projectStatuses/ProjectStatuses';
import AppointmentPurpose from './appointmentPurpose/appointmentPurpose';
import TemplateCategories from './templateCategories/TemplateCategories';
import Tags from './tags/Tags';
import Emojis from './emojis/Emojis';
import WorkDayCalendar from './workDayCalendar/WorkDayCalendar';
import FinancingTypeProjects from './financingTypes/FinancingTypeProjects';
import InitiativeCategories from './initiativeCategories/InitiativeCategories';
import ProjectIndustries from './projectIndustries/ProjectIndustries';
import ProjectTags from './projectTags/ProjectTags';
import ProjectTypes from './projectTypes/ProjectTypes';
import Permission from './permission/permission';
import DocumentCategory from './documentCategory/DocumentCategory';

const References = lazy(() => import('./References'));

const ReferencesConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: authRoles.admin,
  routes: [
    {
      path: 'admin/references',
      element: <References />,
      children: [
        {
          path: 'organizations',
          element: <Organizations />,
        },
        {
          path: 'translations',
          element: <Translations />,
        },
        {
          path: 'claimtypes',
          element: <ClaimTypes />,
        },
        {
          path: 'claimstatuses',
          element: <ClaimStatuses />,
        },
        {
          path: ':tableName',
          element: <Reference />,
        },
        {
          path: 'absence-ask-statuses',
          element: <AbsenceAsksStatuses />,
        },
        {
          path: 'absence-ask-categories',
          element: <AbsenceAsksCategories />,
        },
        {
          path: 'absence-ask-subcategories',
          element: <AbsenceAsksSubCategories />,
        },
        {
          path: 'projectstatuses',
          element: <ProjectStatuses />,
        },
        {
          path: 'financing-type-projects',
          element: <FinancingTypeProjects />,
        },
        {
          path: 'initiative-categories',
          element: <InitiativeCategories />,
        },
        {
          path: 'project-industries',
          element: <ProjectIndustries />,
        },
        {
          path: 'project-tags',
          element: <ProjectTags />,
        },
        {
          path: 'appointment-purpose',
          element: <AppointmentPurpose />,
        },
        {
          path: 'templatecategories',
          element: <TemplateCategories />,
        },
        {
          path: 'tags',
          element: <Tags />,
        },
        {
          path: 'emojis',
          element: <Emojis />,
        },
        {
          path: 'work-calendar',
          element: <WorkDayCalendar />,
        },
        {
          path: 'project-types',
          element: <ProjectTypes />,
        },
        {
          path: 'permission',
          element: <Permission />,
        },
        {
          path: 'document-category',
          element: <DocumentCategory />,
        },
      ],
    },
  ],
};

export default ReferencesConfig;
